import { getTranslation } from './constants';

/** Labels für CashExpectedBreakdown (FR/AR). */
export function getEcartBreakdownLabels(language = 'fr') {
  const lang = language === 'ar' ? 'ar' : 'fr';
  return {
    title: getTranslation('reportsPage.ecartBreakdownTitle', lang),
    hint: getTranslation('reportsPage.ecartBreakdownHint', lang),
    cashSection: getTranslation('reportsPage.ecartBreakdownCashSection', lang),
    initial: getTranslation('reportsPage.ecartBreakdownInitial', lang),
    cashSales: getTranslation('reportsPage.ecartBreakdownCashSales', lang),
    cashDebtCollections: getTranslation('reportsPage.ecartBreakdownCashDebt', lang),
    cashOutgoing: getTranslation('reportsPage.ecartBreakdownCashOutgoing', lang),
    expectedCash: getTranslation('reportsPage.ecartBreakdownExpectedCash', lang),
    electronicSection: getTranslation('reportsPage.ecartBreakdownElectronicSection', lang),
    initialElectronic: getTranslation('reportsPage.ecartBreakdownInitialElectronic', lang),
    electronicSales: getTranslation('reportsPage.ecartBreakdownElectronicSales', lang),
    electronicDebtCollections: getTranslation('reportsPage.ecartBreakdownElectronicDebt', lang),
    electronicOutgoing: getTranslation('reportsPage.ecartBreakdownElectronicOutgoing', lang),
    expectedElectronic: getTranslation('reportsPage.ecartBreakdownExpectedElectronic', lang)
  };
}
